import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './FooterControls.scss';

export default function FooterControl(props) {
   // console.log('FooterControl called..... ');
   const [value, setValue] = React.useState(30);
   const [prevDeltaScene, setPrevDeltaScene] = React.useState(0);
   const [zoombarValue, setZoombarValue] = React.useState(0);

   const handleChange = (event, newValue) => {
      setValue(newValue);
   };
   var slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
   window.updateSlider = function(){

      slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
      
      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }
   const handleZoomChange = (e, newValue) => {
      window.resetRotationCenter();
      // clearCalloutCanvas();
      if (e) {
         window.scene._nav.NavChangeDolly(undefined, e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined, newValue / 100);
         slider.value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.hidePopUpandHotspot();
      window.hotspot = '';

      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {  We're not validating zoonOutCamStatus, nor are we using the variable. @DS
      //    window.zoonOutCamStatus = false; 
   
         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         // window.UiUtils.handleZoomoutCam(window.zoomOutSequence)
          window.UiUtils.handleZoomoutCam()
         
      // }
       if (e) {
         window.scene._nav.NavChangeDolly(undefined,e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined,newValue / 100);
         slider.value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }

      window.hidePopUpandHotspot();

      if (typeof window.updateSlider === "function") window.updateSlider();
   };

   //only for mob
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;

   const onZoomIn = (e) => {
      window.resetRotationCenter(); // reset rotation center on Reset button click @RT (Ftrack Link - https://hmx.ftrackapp.com/#slideEntityId=02391378-ff65-46cb-b80c-53ec3afc0512&slideEntityType=task&view=tasks&itemId=projects&entityId=549ed20d-f546-4129-9969-9f643fe6f629&entityType=task )
      window.clearCalloutCanvas();
      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null, -1 + (parseFloat(slider.value)))

         // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         //    window.zoonOutCamStatus = false;
      
            // this code is used to hide pop on mouse down
            // var allPopup = document.querySelector('.popup.active');
            // if (allPopup != null) {
            //    allPopup.classList.remove('active');
            // }
            window.hidePopUpandHotspot();
            window.UiUtils.handleZoomoutCam()
         // }
         
   }

   const onZoomOut = (e) => {
      window.resetRotationCenter(); // reset rotation center on Reset button click @RT (Ftrack Link - https://hmx.ftrackapp.com/#slideEntityId=02391378-ff65-46cb-b80c-53ec3afc0512&slideEntityType=task&view=tasks&itemId=projects&entityId=549ed20d-f546-4129-9969-9f643fe6f629&entityType=task )
      window.clearCalloutCanvas();
      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null, 1 + (parseFloat(slider.value)))

         // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         //    window.zoonOutCamStatus = false;
      
            // this code is used to hide pop on mouse down
            // var allPopup = document.querySelector('.popup.active');
            // if (allPopup != null) {
            //    allPopup.classList.remove('active');
            // }
            window.hidePopUpandHotspot();
            window.UiUtils.handleZoomoutCam();
            
         // }
         

         
   }
   const onLeft = () => {
      window.resetRotationCenter(); // reset rotation center on Reset button click @RT (Ftrack Link - https://hmx.ftrackapp.com/#slideEntityId=02391378-ff65-46cb-b80c-53ec3afc0512&slideEntityType=task&view=tasks&itemId=projects&entityId=549ed20d-f546-4129-9969-9f643fe6f629&entityType=task )
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [7, 0]);
      window.hotspot = '';
      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
      window.scene.clearRefine();
      // if (window.selectedButton != 'accordion_interiorFeatur') {
      //    window.selectedButton = '';
      // }
      // window.scene.clearRefine();
      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      //    window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         
      // }
   }
   const onRight = () => {
      window.resetRotationCenter();  // reset rotation center on Reset button click @RT (Ftrack Link - https://hmx.ftrackapp.com/#slideEntityId=02391378-ff65-46cb-b80c-53ec3afc0512&slideEntityType=task&view=tasks&itemId=projects&entityId=549ed20d-f546-4129-9969-9f643fe6f629&entityType=task )
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [-7, 0]);
      window.hotspot = '';
      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
      window.scene.clearRefine();
      // if (window.selectedButton != 'accordion_interiorFeatur') {
      //    window.selectedButton = '';
      // }
      // window.scene.clearRefine();
      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      //    window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         
      // }
   }

   
//New code added 
var animStopped = true;
var conScreenControlHandlerCalled = false;

const onScreenControlHandler = (e) =>{
   console.log('onScreenControlHandler called..... ', conScreenControlHandlerCalled, e.type, e);
   // if(conScreenControlHandlerCalled) return; // Throttle added of 300ms to allow complete the Footer control div animation 
   conScreenControlHandlerCalled = true;
   let onScreenControlsValueLocal = window.UiUtils.domElement.onScreenControlsValue ?? document.querySelector('#onScreenControlsValue');
   //onScreenControlsValueLocal.disabled = true;
   // console.log(e)

   // if(e.type === "keydown" && e.key === "Enter" && e.target.id === "onScreenControlsValue") {
      // onScreenControlsValueLocal.checked = !onScreenControlsValueLocal.checked;
   // }

   const isChecked = onScreenControlsValueLocal.checked;

   

   console.log('isChecked ', window.UiUtils.domElement.onScreenControlsValue.checked);
   if(isChecked){
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if(window.UiUtils.domElement.footerControls) window.UiUtils.domElement.footerControls.classList.add('active');
         window.UiUtils.domElement.onScreenControls.setAttribute('aria-checked', 'true');
         window.UiUtils.domElement.onScreenControlsValue.checked = true;
         // window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.onScreenControls, "checked")
   } else {
         window.animation1SwitchGlobal = 'off';
         window.animationSwitchVal = 'off';
         if(window.UiUtils.domElement.footerControls) window.UiUtils.domElement.footerControls.classList.remove('active');
         window.UiUtils.domElement.onScreenControls.setAttribute('aria-checked', 'false');
         window.UiUtils.domElement.onScreenControlsValue.checked = false;
         // window.UiUtils.domElement.onScreenControlsValue.checked = false;
         // window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.onScreenControls, "not checked")

         // setTimeout(function () {
         //     animStopped = true;
         //  }, 200);
   }

   // Throttle added of 300ms to allow complete the Footer control div animation 
   setTimeout(function(){
      conScreenControlHandlerCalled = false;
      onScreenControlsValueLocal.disabled = false;
      window.UiUtils.setFocusOnElement(window.UiUtils.domElement.onScreenControls);
   }, 300);
    
   if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
   if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaHidden('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
   // if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
}

const onScreenControlHandlerkeyPress = (e) => {
   if(e.type === "keydown" && e.key === "Enter") {
      window.UiUtils.domElement.onScreenControlsValue.checked = !window.UiUtils.domElement.onScreenControlsValue.checked;
      onScreenControlHandler(e);
   }
      
      
}


let { previousView,resetView,nextView } = { ...props.ui };
let { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...props.ui }

    /*Set tooltip top to adjuest position based on no. of lines */
    setTimeout(function(){
      
      let tooltiptext = document.querySelector('.tooltiptext');
      let tooltiptextHeight = 0;
      if(tooltiptext != null){
         const compStylestooltiptext = window.getComputedStyle(tooltiptext);
         tooltiptextHeight = parseInt(compStylestooltiptext.height);
         if(tooltiptextHeight == 27) tooltiptext.style.top = '0px';
         else if(tooltiptextHeight >= 30 && tooltiptextHeight <= 50 ) tooltiptext.style.top = '-8px';
         else if(tooltiptextHeight >= 51 && tooltiptextHeight <= 55 ) tooltiptext.style.top = '-16px';
         else if(tooltiptextHeight >= 56 && tooltiptextHeight <= 65 ) tooltiptext.style.top = '-25px';
         else if(tooltiptextHeight >= 66 && tooltiptextHeight <= 75 ) tooltiptext.style.top = '-37px';
      }
    },1000)
    /*Set tooltip top to adjuest position based on no. of lines end */
   //  console.log('FooterControl window.menuSubmenuTabindex ', window.menuSubmenuTabindex)
   //  console.log('FooterControl called..... ')

   return (
      <React.Fragment>
        {ReactDOM.createPortal(
            <div id="onScreenControl" className='tooltip'>
            <span className='' aria-hidden="true">{onScreenControls}
                <span className="tooltiptext">{hovertext}</span>
            </span>
            <label key={"onScreenControls"} className="switch" tabIndex="-1" data-tabindex={1} id="onScreenControls" onKeyDownCapture={onScreenControlHandlerkeyPress} role='switch' aria-label={"On-Screen Controls"} >
                <input tabIndex="-1" className="tabIndexStyle" name='onScreenControlsValue' id="onScreenControlsValue" type="checkbox" onChange={onScreenControlHandler} defaultChecked={false} aria-checked={false} />
                <span className="tabIndexStyle slider round" ></span>
                <span className="onOff"></span>
            </label>
            </div>, document.getElementById('onScreenControlContainer'))
        }
         {ReactDOM.createPortal(
            <div id='footerControls' className="footerControlsDesk">
               {/* <div className="threebtns"> */}
                  <div className="zoombarandRotateContainer">

                     {/* <div className='topbtns'> */}

                        <button type="button" role="button" className='btn rotateBtn left' aria-label="Rotate Left" id="rLeft" tabIndex="-1"  data-tabindex={1} onClick={onLeft} title="left">
                           <img alt="Rotate left" src="./images/footerControls/diagonalLeftArrow.svg" />
                        </button>
                        <button type="button" role="button" className='btn rotateBtn right' aria-label="Rotate Right" id="rRight" tabIndex="-1" data-tabindex={1} onClick={onRight} title="right">
                           <img alt="Rotate right" src="./images/footerControls/diagonalRightArrow.svg" />
                        </button>
                     {/* </div> */}

                     <div id="zoomSliderContainer " className='zoombar'>
                        <img alt="zoombar" aria-hidden="true" src="./images/footerControls/zoombar.svg" />

                        <button tabIndex="-1" data-tabindex={1} aria-label="clickable zoom out" className='btn zoomIn' type="button" role="button" id="zoomIn" onClick={onZoomIn}> </button>
                        {/* <div id="zoomSlider" aria-hidden="true"> */}
                           <div className="rangeslider" aria-hidden="true">
                              <label> <input tabIndex="-1" aria-hidden="true" type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                              </label>
                           {/* </div> */}
                        </div>
                        <button tabIndex="-1" data-tabindex={1} aria-label="clickable zoom in" className='btn zoomOut' type="button" id="zoomOut" role="button" onClick={onZoomOut}></button>
                     </div>
                  </div>
                  <div className='nextPrevConatiner' >
                     <button tabIndex="-1" data-tabindex={1} className='btn previousView threeButtons' aria-label="Previous view" id="previousView" variant="outlined" onClick={e=>props.onPrevious(e)} >
                        <div className='icon'>
                           <img alt="Previous view" src="./images/footerControls/leftArrow.svg" />
                        </div>
                        <div className='text'>
                           {previousView !== undefined ? previousView : 'Previous View'}
                        </div>
                     </button>
                     <button tabIndex="-1" data-tabindex={1} className='btn resetView threeButtons' variant="outlined" id="resetView" onClick={e=>props.onReset(e)} >
                        {resetView !== undefined ? resetView : 'Reset View'}
                     </button>
                     <button tabIndex="-1" data-tabindex={1} className='btn nextView threeButtons' aria-label="Next view" id="nextView" variant="outlined" onClick={e=>props.onNext(e)} expanded={props.expanded} >
                        <div className='text'>
                           {nextView !== undefined ? nextView : 'Next View'}
                        </div>
                        <div className='icon'>
                           <img alt="Next view" src="./images/footerControls/rightArrow.svg" />
                        </div>
                     </button>
                  </div>
               {/* </div> */}
            </div>,document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
